export const classNames = (...c: string[]) => c.filter(Boolean).join(' ');
